"use strict";
var wall = document.querySelector(".wall");
var spider = document.querySelector(".spider");
wall.addEventListener("click", function(e) {
    var rect = wall.getBoundingClientRect();
    var styles = getComputedStyle(wall);
    var borderLeft = parseFloat(styles.borderLeftWidth);
    var borderTop = parseFloat(styles.borderTopWidth);
    var x = e.clientX - rect.left - borderLeft;
    var y = e.clientY - rect.top - borderTop;
    x -= spider.offsetWidth / 2;
    y -= spider.offsetHeight / 2;
    var maxX = wall.clientWidth - spider.offsetWidth;
    var maxY = wall.clientHeight - spider.offsetHeight;
    x = Math.max(0, Math.min(x, maxX));
    y = Math.max(0, Math.min(y, maxY));
    spider.style.left = "".concat(x, "px");
    spider.style.top = "".concat(y, "px");
});

//# sourceMappingURL=index.faf2e070.js.map
